import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { useState } from "react";
import { getQueryClient } from "@/services/get-query-client";
import Dashboard from '@/components/dashboard/DashboardPage';
import EmbeddedAvatar from '@/components/embedded-avatar/embedded-avatar';
import SignInWrapper from '@/components/ui/custom/sign-in-wrapper';
import LandingPagePreview from '@/components/landing-page-preview/landing-page-preview';

function App() {
  const [queryClient] = useState(() => getQueryClient());

  return (
    <QueryClientProvider client={queryClient}>
      <div className="h-full">
        <Router>
          <Routes>
            <Route path="/" element={<SignInWrapper><Dashboard /></SignInWrapper>} />
            <Route path="/avatar" element={<EmbeddedAvatar />} />
            <Route path="/preview" element={<LandingPagePreview />} />
          </Routes>
        </Router>
      </div>
      <ReactQueryDevtools initialIsOpen={false} />
    </QueryClientProvider>
  );
}

export default App;
